<template>
  <div class="snapshot-record">
    <template v-if="Array.isArray(normalized) && normalized.length">
      <template v-if="recordArray">
        <AppFormField v-if="normalized.length > 1" design="new" label="Saved record" class="snapshot-record__picker">
          <AppSelect v-model="selectedIndex" design="new" :options="recordOptions" :reduce="option => option.index" label="name" :clearable="false" />
        </AppFormField>
        <SnapshotTable :value="normalized[selectedIndex]" />
      </template>
      <ul v-else class="snapshot-record__list"><li v-for="(item, index) in normalized" :key="index">{{ display(item) }}</li></ul>
    </template>
    <template v-else-if="normalized && typeof normalized === 'object' && !Array.isArray(normalized)">
      <dl v-if="fields.length" class="snapshot-record__fields">
        <div v-for="field in fields" :key="field.key" :class="{ 'snapshot-record__wide': String(field.value || '').length > 100 }"><dt>{{ label(field.key) }}</dt><dd>{{ display(field.value) }}</dd></div>
      </dl>
      <section v-for="field in sections" :key="field.key" class="snapshot-record__section">
        <h4>{{ label(field.key) }}</h4><SnapshotTable :value="field.value" />
      </section>
      <p v-if="!fields.length && !sections.length" class="snapshot-record__empty">No saved details.</p>
    </template>
    <p v-else class="snapshot-record__empty">{{ display(normalized) }}</p>
  </div>
</template>
<script>
import AppSelect from '@/components/AppSelect'
import AppFormField from '@/components/AppFormField'
function unpack(value) {
  if (typeof value !== 'string' || !/^[\[{]/.test(value.trim())) return value
  try { const parsed = JSON.parse(value); return parsed && typeof parsed === 'object' ? parsed : value } catch (_) { return value }
}
function nested(value) { return value && typeof value === 'object' && Object.keys(value).length > 0 }
export default {
  name: 'SnapshotTable',
  components: { AppSelect, AppFormField },
  props: { value: { default: null } },
  data() { return { selectedIndex: 0 } },
  computed: {
    normalized() { return unpack(this.value) },
    entries() { return Object.entries(this.normalized || {}).map(([key, value]) => ({ key, value: unpack(value) })) },
    fields() { return this.entries.filter(field => !nested(field.value)) },
    sections() { return this.entries.filter(field => nested(field.value)) },
    recordArray() { return this.normalized.some(item => item && typeof item === 'object') },
    recordOptions() { return this.normalized.map((record, index) => { const item = record || {}; const product = unpack(item.product || item.item_snapshot || item.item || {}); const name = item.client_name || item.name || (product && product.name) || [item.first_name, item.last_name].filter(Boolean).join(' ') || 'Record'; return { index, name: `${index + 1}. ${name}${item.id ? ` · #${item.id}` : ''}` } }) }
  },
  watch: { value() { this.selectedIndex = 0 } },
  methods: {
    label(key) {
      const names = { id: 'ID', dob: 'Date of birth', count: 'Quantity', price: 'Unit price', item_id: 'Product ID', client_id: 'Participant ID', group_id: 'Group ID', created_by_id: 'Created by · user ID', updated_by_id: 'Updated by · user ID', item_snapshot: 'Product', payment_logs: 'Payment references', participant: 'Safari participant', client: 'Client', orders: 'Snackbar orders', stripe: 'Stripe', kassa: 'Kassa', qa_only: 'Test record' }
      return names[key] || key.replace(/_/g, ' ').replace(/\bid\b/g, 'ID').replace(/^./, letter => letter.toUpperCase())
    },
    display(value) {
      if (value === null || value === undefined || value === '') return '—'
      if (typeof value === 'boolean') return value ? 'Yes' : 'No'
      if (typeof value === 'object') return 'None recorded'
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}(T|$)/.test(value) && !Number.isNaN(Date.parse(value))) return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', ...(value.includes('T') ? { timeStyle: 'short', timeZone: 'Africa/Dar_es_Salaam' } : { timeZone: 'UTC' }) }).format(new Date(value))
      return value
    }
  }
}
</script>
<style lang="scss" scoped>
.snapshot-record {
  min-width: 0;
  &__picker { max-width: 620px; margin-bottom: $ui-space-16; }
  &__fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 $ui-space-24; margin: 0; }
  &__fields > div { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr); gap: $ui-space-16; padding: $ui-space-8 0; border-bottom: 1px solid $ui-line; align-items: baseline; }
  dt { color: $ui-muted; overflow-wrap: anywhere; }
  dd { margin: 0; text-align: right; overflow-wrap: anywhere; white-space: pre-wrap; font-weight: 500; }
  &__wide { grid-column: 1 / -1; }
  &__section { margin-top: $ui-space-16; padding: $ui-space-16; border: 1px solid $ui-line; border-radius: $ui-control-radius; background: $ui-surface; min-width: 0; }
  h4 { font-weight: 600; color: $ui-ink; margin: 0 0 $ui-space-12; }
  &__empty { margin: 0; color: $ui-muted; }
  &__list { padding-left: $ui-space-20; overflow-wrap: anywhere; }
  @media (max-width: 760px) { &__fields { grid-template-columns: minmax(0, 1fr); } &__section { padding: $ui-space-12; } }
}
</style>
